var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgTagClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "8px",
  height: "8px",
  viewBox: "0 0 8 8",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1113.000000, -408.000000) translate(1111.000000, 406.000000)",
  opacity: 0.8
}, /*#__PURE__*/React.createElement("rect", {
  fillOpacity: 0,
  fill: "#D8D8D8",
  width: 12,
  height: 12
}), /*#__PURE__*/React.createElement("polygon", {
  points: "10 2.92121342 9.03092612 2 6 5.19512142 2.96907388 2 2 2.92121342 4.91843282 5.99803695 2.00124123 9.07491871 2.96566263 10 6 6.80013234 9.03433737 10 9.99875877 9.07491871 7.08082891 5.99803695"
}))));

export default SvgTagClose;